import { render, staticRenderFns } from "./fileUpload.vue?vue&type=template&id=1c12ffac&"
import script from "./fileUpload.vue?vue&type=script&lang=js&"
export * from "./fileUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c12ffac')) {
      api.createRecord('1c12ffac', component.options)
    } else {
      api.reload('1c12ffac', component.options)
    }
    module.hot.accept("./fileUpload.vue?vue&type=template&id=1c12ffac&", function () {
      api.rerender('1c12ffac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/invoice/components/fileUpload.vue"
export default component.exports